import { Outlet } from "react-router-dom"

const Layout = () => {
    return (
        <main className="flexGrowContainer">
            <Outlet className="flexGrow"/>
        </main>
    )
}

export default Layout
